import { alertaFalha, toastAviso, toastErro, toastSucesso } from '../utils/toast';

// Feedback global do sistema. Mantém a API `useSnackbar()` usada pelas telas,
// agora servida por SweetAlert2 (toasts) em vez do Snackbar do MUI:
//   sucesso/erro/aviso — toast discreto no canto
//   falha(error, padrao) — modal com a lista quando há vários erros de validação
const feedback = {
    sucesso: toastSucesso,
    erro: toastErro,
    aviso: toastAviso,
    falha: alertaFalha,
};

export const useSnackbar = () => feedback;

// SweetAlert2 renderiza sozinho (sem provider). Mantido para não quebrar o
// App.js e futuros consumidores; apenas repassa os filhos.
export const SnackbarProvider = ({ children }) => children;
